<template>
    <button
        class="o-w-item-search-category-tile  w-item-search-category-tile w-item-tile--odd-background"
        type="button"
        role="button"
        :aria-label="`${ariaLabel}${t(item, 'name')}`"
        @click="onClick"
    >
        <div class="w-item-search-category-tile__logo-wrapper">
            <img
                v-if="t(item, 'icon')"
                :src="t(item, 'icon')"
                alt="logo image"
                class="w-item-search-category-tile__logo"
            />
            <svg-icon
                v-else
                original
                name="icons/category-logo"
                class="w-item-search-category-tile__logo--default"
            />
        </div>

        <div class="w-item-search-category-tile__wrapper">
            <span class=" w-item-search-category-tile__title">
                {{ t(item, 'name') }} 
            </span>
            <span 
                class=" w-item-search-category-tile__subtitle"
            >
                {{subtitle}}                            <!-- {{ t(item, 'name') }}TO DO: replace name to needed data -->
            </span>
        </div>
        <svg-icon
            original
            name="icons/plus-dark"
            class="w-item-search-category-tile__icon"
        />
    </button>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'OWItemSearchCategoryTile',
    props: {
        item: {
            type: Object,
            default: () => ({})
        },
        ariaLabel: {
            type: String,
            default: 'Title - '
        },
        isService: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getCategoryById',
            'getDenormalisedObjectById'
        ]),
        denormalisedObject() {
            return this.getDenormalisedObjectById(this.item.id);
        },
        subtitle() {
            return `${this.t(this.item, 'objectsCount') || 0} ${this.isService ? this.$t('ui.services-open') : this.$t('ui.stores-open')}`
        }
    },
    methods: {
        onClick() {
            this.$emit('onClick', {
                ...this.item,
                serviceCategory: true
            })
        }
    }
}
</script>

<style lang="scss">
@import "o-w-item-search-category-tile";
</style>